<template src="./GenericPasswordChangeForm.html"></template>

<script lang="ts">
import { defineComponent } from "vue";
import FieldData from "@/services/fieldData";
import { VForm } from "vuetify/lib/components/VForm/VForm";

export default defineComponent({
    emits: ["submit"],
    methods: {
        async submitForm(): Promise<void> {
            if (!(await (this.$refs.form as VForm).validate()).valid) return;
            this.$emit("submit", this.password);
        },
        passwordConfirmMatchRule(p: string): boolean | string {
            return (
                p === this.password ||
                "Password and Confirm Password do not match"
            );
        }
    },
    data() {
        const passwordRequiredPattern =
            /^(?=.*["!$%&/()=?~{[\]}\\@+\-_#'<>|,;.:])(?=.*[a-zA-Z])(?=.*\d).*$/;
        const passwordAllowedPattern =
            /^[A-Za-z\d!"$%&/()=?~{[\]}\\@+\-_#'<>|,;.:]*$/;
        const requiredCharacters =
            "Password must contain at least one number, one letter and one of these special character: " +
            " ! \" $ % & / ( ) = ? ~ { [ ] } \\ @ + - _ # ' < > | , ; . :";
        const allowedSpecialCharacters =
            "Password may only contain roman letters, numbers and these special characters:" +
            " ! \" $ % & / ( ) = ? ~ { [ ] } \\ @ + - _ # ' < > | , ; . :";

        const passwordData = new FieldData("Password", {
            required: true,
            minLength: 6,
            maxLength: 40
        });
        const repeatPasswordData = new FieldData("Confirm password", {
            required: true
        });

        return {
            passwordRequiredPattern,
            passwordAllowedPattern,
            requiredCharacters,
            allowedSpecialCharacters,
            passwordData,
            repeatPasswordData,
            passwordRules: [
                ...passwordData.rules,
                (p: string): boolean | string =>
                    passwordRequiredPattern.test(p) || requiredCharacters,
                (p: string): boolean | string =>
                    passwordAllowedPattern.test(p) || allowedSpecialCharacters
            ],
            password: "",
            passwordConfirm: ""
        };
    },
    computed: {
        repeatPasswordRules() {
            return [
                ...this.repeatPasswordData.rules,
                (p: string): boolean | string =>
                    p === this.password ||
                    "Password and Confirm Password do not match"
            ];
        }
    }
});
</script>
